import { IMDTAirdropHistoryItemDTO } from 'interfaces/api/mdtBalance'

export const Subscription: TAnt.TableColumnRender<IMDTAirdropHistoryItemDTO['subscription']> = (
  subscription
) => <>{subscription?.name}</>
